import * as React from 'react';

const PlaySoundTriangleIcon = ({fillColor = '#2D2756'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill={fillColor}
    viewBox="0 0 5.784 7.026">
    <path
      d="M.006.775v5.441a.721.721 0 0 0 1.081.71l4.319-2.76a.783.783 0 0 0 0-1.341L1.087.065a.771.771 0 0 0-1.081.71Z"
      fill={fillColor}
    />
  </svg>
);

export default PlaySoundTriangleIcon;
